// extracted by mini-css-extract-plugin
module.exports = {"actionTemplate":"ActionsColumn_actionTemplate__oBUXa","editRowButton":"ActionsColumn_editRowButton__1tz7J","deleteRowButton":"ActionsColumn_deleteRowButton__2rDMb"};